import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';

type Props = {
	imageUrl: string;
	name: string;
	withBorder?: boolean;
};

const ArticleProfile = ({ imageUrl, name, withBorder }: Props) => (
	<Container>
		<ImageWrapper src={imageUrl} alt={name} withBorder={withBorder} />
		<NameWrapper>
			<span>{name}</span>
		</NameWrapper>
	</Container>
);

export default ArticleProfile;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	display: 'flex',
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const ImageWrapper = styled.img<{ withBorder?: any }>((props) => ({
	maxHeight: token('space.300', '24px'),
	maxWidth: token('space.300', '24px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderRadius: props.withBorder ? '50%' : 0,
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const NameWrapper = styled.div({
	lineHeight: '24px',
	paddingLeft: token('space.150', '12px'),
});
